import { render } from "./BackgroundEditor.vue?vue&type=template&id=3515b564&scoped=true"
import script from "./BackgroundEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundEditor.vue?vue&type=script&lang=js"

import "./BackgroundEditor.vue?vue&type=style&index=0&id=3515b564&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3515b564"

export default script